// src/components/Gallery/MinimalLayout.js
import React from 'react';
import { MediaComponent } from './MediaComponents';
import CategorySeparator from './CategorySeparator';

const MinimalLayout = ({ sections, onImageClick }) => {
  let artworkIndex = 0; // Track artwork position for priority

  return (
    <div className="portfolio-minimal-grid-layout">
      {sections.map((item, index) => {
        if (item.type === 'category') {
          return (
            <CategorySeparator 
              key={`category-${index}`} 
              category={item} 
            />
          );
        }
        
        // High priority for first 6 artworks in grid layout
        const priority = artworkIndex < 6 ? 'high' : 'normal';
        artworkIndex++;
        
        // Regular artwork rendering
        return (
          <div key={item.id} className="portfolio-minimal-grid-item">
            <MediaComponent 
              item={item}
              priority={priority}
              onClick={() => onImageClick(item)}
            />
            <div className="portfolio-minimal-grid-label">
              <div className="portfolio-minimal-grid-label-title">{item.title}</div>
              <div className="portfolio-minimal-grid-label-info">
                <div className="portfolio-minimal-grid-label-line">{item.year}</div>
                <div className="portfolio-minimal-grid-label-line">{item.medium}</div>
                <div className="portfolio-minimal-grid-label-line">{item.dimensions}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MinimalLayout;